//-------------------------------------------------------------
// START: scroll spy
//-------------------------------------------------------------

// handle function for the active item when in IO
let activeNavLink = false;
let activeNavClass;

export const initScrollSpy = ($el, spyTargetClass, activeClass = ['fsa-micro-nav__active'], intersectionObserverOptions) => {
  activeNavClass = activeClass;
  initMicroNavScrollListener($el, spyTargetClass, intersectionObserverOptions);
}

const handleMicroNavScrollListenerStep = (entries) => {

  entries.forEach(({target: {id}, isIntersecting}) => {

    // find the related html micro nav link where href matches id on the desktop nav
    const relatedNavLink = document.getElementById('js-micro-nav-desktop').querySelector(`[href="#${id}"]`);

    if (isIntersecting && relatedNavLink && relatedNavLink != activeNavLink) {
      // set related nav link to active classes
      relatedNavLink.classList.add(...activeNavClass)

      if (activeNavLink) {
        activeNavLink.classList.remove(...activeNavClass);
      }

      activeNavLink = relatedNavLink;
    }

  });

}


//  intersection observes that updates the nav if you were to scroll there manually
const initMicroNavScrollListener = ($el, spyTargetClass, intersectionObserverOptions) => {
  const sections = [...$el.querySelectorAll(`.${spyTargetClass}`)]

  const ioOptions = intersectionObserverOptions ?? {
    threshold: 0, // detect when visibility passes this percent
    rootMargin: "-30% 0px -60%",
  };

  const io = new IntersectionObserver(handleMicroNavScrollListenerStep, ioOptions);

  io.POLL_INTERVAL = 100; // Time in milliseconds

  sections.forEach((section) => {
    io.observe(section);
  });

}
//-------------------------------------------------------------
// END: spyscroll
//-------------------------------------------------------------